import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Floatingcall from "../components/floatingbutton/Floatingcall";
import { Helmet } from "react-helmet";
import LandingPageClient from "../components/ladingpageclient/LandingPageClient";

function PantryBoyServices(){

  const scrollToTop = () => {
    window.scrollTo(0, 0)
}

const testimonials = [
  {
    name: "Rahul Sharma",
    role: "Business Owner",
    feedback:
      "After Helper Ji’s pantry boy started, the pantry stays clean even during busy hours. Thanks to this great company.",
    image: "https://i.pravatar.cc/150?img=12",
  },
  {
    name: "Neha Verma",
    role: "Working Professional",
    feedback:
      "Tea, water, and basic pantry work are handled properly by HelperJi pantry staff. We are glad that we found this service provider.",
    image: "https://i.pravatar.cc/150?img=32",
  },
  {
    name: "Amit Singh",
    role: "Corporate Manager",
    feedback:
      "Meetings run better now because Helper Ji's pantry boy keeps refreshments ready on time.",
    image: "https://i.pravatar.cc/150?img=56",
  },
];

    return(
        <Fragment>
          <Helmet>
        <title>
          Best Pantry Boy Services | Professional Pantry Staff & Manpower Services
        </title>

        <meta
          name="description"
          content="Professional pantry boy services offering trained pantry staff, office pantry boys & reliable pantry manpower services for offices, corporates & commercial workplaces near you."
        />

        <meta
          name="keywords"
          content="Pantry Boy Services, Professional Pantry Boy Services, Pantry Staff Services, Office Pantry Boy, Office Pantry Staff Services, Corporate Pantry Staff, Corporate Pantry Boy Services, Pantry Manpower Services, Trained Pantry Staff, Reliable Pantry Manpower, Commercial Pantry Services"
        />

        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta name="bingbot" content="index, follow" />
        <meta name="revisit-after" content="daily" />
        <meta name="allow-search" content="yes" />
        <meta name="copyright" content="Helper Ji" />

        {/* ===== CANONICAL ===== */}
        <link
          rel="canonical"
          href="https://www.helperji.in/pantry-boy-services"
        />

        {/* ===== OPEN GRAPH ===== */}
        <meta
          property="og:title"
          content="Best Pantry Boy Services | Professional Pantry Staff & Manpower Services"
        />
        <meta
          property="og:description"
          content="Professional pantry boy services offering trained pantry staff, office pantry boys & reliable pantry manpower services for offices, corporates & commercial workplaces near you."
        />
        <meta
          property="og:image"
          content="https://www.helperji.in/assets/img/Pantry-Boy-Services-1.jpg"
        />
        <meta property="og:site_name" content="Helper Ji" />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.helperji.in/pantry-boy-services"
        />

        {/* ===== TWITTER META ===== */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@helperji_" />
        <meta name="twitter:creator" content="@helperji_" />
        <meta
          name="twitter:title"
          content="Best Pantry Boy Services | Professional Pantry Staff & Manpower Services"
        />
        <meta
          name="twitter:description"
          content="Professional pantry boy services offering trained pantry staff, office pantry boys & reliable pantry manpower services for offices, corporates & commercial workplaces near you."
        />
        <meta
          name="twitter:image"
          content="https://www.helperji.in/assets/img/Pantry-Boy-Services-1.jpg"
        />

        {/* ===== WEBPAGE SCHEMA ===== */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "url": "https://www.helperji.in/pantry-boy-services",
            "name": "Best Pantry Boy Services | Professional Pantry Staff & Manpower Services",
            "description": "Professional pantry boy services offering trained pantry staff, office pantry boys & reliable pantry manpower services for offices, corporates & commercial workplaces near you."
          }
          `}
        </script>

        {/* ===== PRODUCT SCHEMA ===== */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Product",
            "name": "Pantry Boy Services",
            "image": "https://www.helperji.in/assets/img/Pantry-Boy-Services-1.jpg",
            "description": "Professional pantry boy services offering trained pantry staff, office pantry boys & reliable pantry manpower services for offices, corporates & commercial workplaces near you.",
            "brand": {
              "@type": "Brand",
              "name": "Helper Ji"
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.9",
              "ratingCount": "678"
            }
          }
          `}
        </script>

        {/* ===== BREADCRUMB SCHEMA ===== */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.helperji.in"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Pantry Boy Services",
                "item": "https://www.helperji.in/pantry-boy-services"
              }
            ]
          }
          `}
        </script>
          <script type="text/javascript">
    {`
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "vuhgim22tp");
    `}
  </script>
          </Helmet>
            
            <Floatingcall />
         
            <section id="about" class="about">
            <div class="container" data-aos="fade-up">

            <div class="section-header">
            <h2>Pantry Boy Services</h2>
            <p>Ensuring Smooth Operations & Impeccable Service with Helper Ji</p>
             </div>

           <div class="row gy-4">
           <div class="col-lg-6">
            <img src="/assets/img/Pantry-Boy-Services-1.jpg" class="img-fluid rounded-4 mb-4" alt="" />
            </div>
          
          <div class="col-lg-6">
            <div class="content ps-0 ps-lg-5">
              <p className="text-justify">
              At HelperJi, we understand that a well-managed pantry is essential for the smooth functioning of any organization. Our Pantry Boys Services are designed to ensure that your workplace runs efficiently, with refreshments and essential supplies always available, and a clean, organized environment maintained at all times.
              </p>
              <p className="fs-5 fw-bold">What We Offer:</p>
              <p className="text-justify"><strong>Refreshment Management:</strong> Our pantry boys are skilled in managing a wide range of refreshments, including beverages, snacks, and more. </p>
              <p className="text-justify"><strong>Inventory Control:</strong> Keeping track of pantry supplies can be challenging. Our team diligently monitors inventory levels, ensuring timely restocking of essentials like tea, coffee, sugar, milk, and other items. </p>
              <p className="text-justify"><strong>Hygiene & Cleanliness:</strong> Maintaining a clean and sanitary pantry is crucial for the health and well-being of everyone in your organization.</p>
              <p className="text-justify"><strong>Guest Hospitality:</strong> Our pantry boys are also trained to provide courteous and professional service to your guests. </p>
            </div>
          </div>
        </div>

      </div>
    </section>

    <section id="services" class="services sections-bg">
          <div class="container" data-aos="fade-up">
    
            <div class="row gy-4">
              
              <div class="col-lg-6">
                <div class="content ps-0 ps-lg-5">
                  <h2>Why Choose HelperJi ?</h2>
                  <p className="text-justify"><strong>Trained Professionals:</strong> Our pantry boys are thoroughly trained and experienced in delivering high-quality service.</p>
                  <p className="text-justify"><strong>Reliability:</strong> We pride ourselves on punctuality and dependability, ensuring your pantry is always well-managed.</p>
                  <p className="text-justify"><strong>Attention to Detail:</strong> Our team is detail-oriented, ensuring that every aspect of pantry management is handled with care.</p>
                  <p className="text-justify"><strong>Flexible Solutions:</strong> We offer tailored solutions that can be adjusted to suit the changing needs of your organization.</p>
                  <p className="fs-5 fw-bold">Get in Touch</p>
                  <p className="text-justify">If you're looking for reliable and professional pantry boys services, HelperJi is here to help. Contact us today to discuss your needs and learn more about how we can support your organization with our expert pantry management services.</p>
                </div>
              </div>
              <div class="col-lg-6">
                <img src="/assets/img/Pantry-Boy-Services-2.jpg" class="img-fluid rounded-4 mb-4" alt="" />
              </div>
            </div>
    
          </div>
        </section>

            <section className="py-5 bg-white">
      <div className="container">
        {/* Heading */}
        <div className="text-center mb-5">
          <h2 className="fw-bold">What Our <span style={{ color: "#ED1C24" }}>Clients Say</span> </h2>
          <p className="text-muted">
            Trusted by thousands of satisfied customers
          </p>
        </div>

        {/* Testimonials */}
        <div className="row g-4">
          {testimonials.map((item, index) => (
            <div className="col-md-6 col-lg-4" key={index}>
              <div className="card bg-light h-100 shadow-sm border-0 text-center p-4">
                <img
                  src={item.image}
                  alt={item.name}
                  className="rounded-circle mx-auto mb-3"
                  width="90"
                  height="90"
                />

                <p className="text-muted fst-italic">
                  “{item.feedback}”
                </p>

                <h5 className="fw-semibold mb-0">{item.name}</h5>
                <small className="text-danger">{item.role}</small>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

        <section id="services" class="services sections-bg">
        <div className="container">
          <h3 className="pb-4">
            Pantry Boy Services – FAQs
          </h3>
          <div class="accordion accordion-flush" id="accordionFlushExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne"
                  aria-expanded="false"
                  aria-controls="flush-collapseOne"
                >
                What tasks are included in pantry boy services?
                </button>
              </h2>
              <div
                id="flush-collapseOne"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingOne"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Pantry services include making tea and coffee, serving water, maintaining pantry cleanliness, and assisting during meetings.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingTwo">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseTwo"
                  aria-expanded="false"
                  aria-controls="flush-collapseTwo"
                >
                  Are pantry boys trained for office environments?
                </button>
              </h2>
              <div
                id="flush-collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingTwo"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                 Yes, they are trained to follow office discipline, hygiene standards, and basic service etiquette.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseThree"
                  aria-expanded="false"
                  aria-controls="flush-collapseThree"
                >
                Can pantry services be customized based on office size?
                </button>
              </h2>
              <div
                id="flush-collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingThree"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Yes, services can be adjusted depending on office strength, working hours, and pantry workload.
                </div>
              </div>
            </div>
             <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFour">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFour"
                  aria-expanded="false"
                  aria-controls="flush-collapseFour"
                >
                 Who manages pantry inventory like tea, coffee, and supplies?
                </button>
              </h2>
              <div
                id="flush-collapseFour"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFour"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                 The pantry staff manages daily usage, while purchase responsibility can be handled by the client or as agreed.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFive">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFive"
                  aria-expanded="false"
                  aria-controls="flush-collapseFive"
                >
                  Can pantry boy services be provided on a part-time basis?
                </button>
              </h2>
              <div
                id="flush-collapseFive"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFive"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
               No, only full-time and full-day pantry services are available.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

       <LandingPageClient />
        </Fragment>
    )
}

export default PantryBoyServices;